import React from 'react';

import AggregateShellComponent from "core/gd-modules/common/aggregate/aggregate-shell";

export default function AggregateSpentEstimate(options, props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const val = isValid ? gd.utils.floorToDecimals(props.value, 0) : null;

    const excess = val > 100;
    const value = excess ?  Math.floor(100 * (100 / val)) : val;

    return (
        <AggregateShellComponent className="aggregate-spent-estimate" options={options} noData={!isValid} hint={value + "%"} {...props}>
            {isValid &&
            <div className="gd-select-progress">
                <div className={Classes("ui5-progress", "bar-50", {'excess-v2': excess})}>
                    <div className="progress-bg">
                        {!!value && <div className="progress-line" style={{width:'{0}%'.f(value > 100 ? 100 : value)}}/>}
                    </div>

                    <div className="progress-label ui5-txt-less-important-small percentage">{val}%</div>
                </div>
            </div>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{gd.const.aggregate.label[props.aggregateFunction]}</div>}
        </AggregateShellComponent>
    );
}
